import React from 'react';
import FilterScroller from '../FilterScroller';
import '../../styles/crmScroll.css';

// Reuse the portal's scroll tracking and chevrons without its filter-button styling.
export default function CRMScrollRow({ children, className, ariaLabel, as = 'div', role, alwaysVisible = false }) {
    return <FilterScroller className={`crm-scroll-strip ${className}-strip${alwaysVisible ? ' crm-always-visible' : ''}`} baseRowClassName="" rowClassName={className} rowAs={as} role={role || (as === 'nav' ? undefined : 'group')} ariaLabel={ariaLabel} scrollLabel={(ariaLabel || 'options').toLowerCase()}>{children}</FilterScroller>;
}
